import { WidgetStyles } from './data.model';
import { IDeliveryTerminalInfo } from './organizationInfo/deliveryTerminal/deliveryTerminal.model';
import { IDiscountMetadata } from './organizatioMetadata.model';

export interface Organization {
  deliveryTerminals: IDeliveryTerminalInfo[];
  menu: Menu;
  id: string;
  code: string;
  externalId: string;
  name: string;
  language: string;
  currency: string | null;
  phone: number | null;
  logo: string | null;
  mainColor: string | null;
  secondColor: string | null;
  thirdColor: string | null;
  timeZone: number | null;
  contacts: string;
  userAgreementUrl: string;
  isSupportDelivery: boolean;
  isSupportTakeaway: boolean;
  isSupportDeliveryZones: boolean;
  isQRMenu: boolean;
  styles: WidgetStyles;
  aboutCompany: string;
  confidentialPolicy: string;
  metadata: OrganizationMetadata;
}

export interface OrganizationMetadata {
  yandexMetricId: number | null;
  yandexMapsToken: string;
  discount: IDiscountMetadata;
}

export interface Menu {
  products: Product[];
  productGroups: ProductGroup[];
  productGroupsInfo: ProductGroupInfo[];
  sizes: MenuSize[];
}

export interface MenuSize {
  id: string;
  name: string;
}

export interface Product {
  id: string;
  name: string;
  description: string;
  deliveryTerminalId: string;
  tags: string[];
  productGroups: string[];
  kind: number;
  /**
   * Первая картинка из массива imageLinks
   */
  coverImage: string;
  imageLinks: string[];
  sort: number;
  sizes: ProductSize[];
  productGroupInfo: ProductGroupInfo;
  modifiers: ProductModifier[];
}

export interface ProductGroupInfo {
  id: string;
  name: string;
  isGroupModifier: boolean;
  isIncludedInMenu: boolean;
  sort: number;
}

export interface ProductGroup {
  id: string;
  defaultAmount: number;
  minAmount: number;
  maxAmount: number;
  modifiers: ProductModifier[];
  productGroupInfo: ProductGroupInfo;
}

export const DEFAULT_SIZE_ID = '';

export interface ProductSize {
  id: string;
  name: string;
  price: number;
}

export interface ProductModifier {
  id: string;
  defaultAmount: number;
  name: string;
  sizes: ProductSize[];
  // TODO нужно будет это выпилить и использовать правильную цену из prices
  /**
   * @deprecated
   */
  defaultPrice: number;
  maxAmount: number;
  minAmount: number;
  required: boolean;
  order: number;
}

